import axios from 'axios'
import store from '@/store'

const service = axios.create({
    baseURL: process.env.VUE_APP_FP,
    headers: {
        'X-API-KEY': process.env.VUE_APP_KEY
    },
    timeout: 3600000
})

service.interceptors.request.use(
    config => {
        if (store.state.refRegister.sessionToken) {
            config.headers = Object.assign({}, config.headers, {
                'X-Session-Token': ` ${store.state.refRegister.sessionToken}`
            })
        }

        return config
    },
    error => Promise.reject(error)
)

export default service
